import React from 'react';
import { Link } from 'react-router-dom';
import { FaUserShield, FaDesktop, FaCarSide, FaMicrochip, FaMapMarkedAlt, FaChevronRight } from 'react-icons/fa';
import './hero.css';
import heroImage from '../../Assets/heroSectionimages/RSS_Security_Team.webp';

const features = [
  { icon: FaUserShield, label: 'Highly Trained Security Officers' },
  { icon: FaDesktop, label: '24/7 Command & Control Centre' },
  { icon: FaCarSide, label: 'Rapid Response Teams' },
  { icon: FaMicrochip, label: 'Advanced Security Technology' },
  { icon: FaMapMarkedAlt, label: 'Nationwide Coverage' },
];

const HeroSection = () => {
  return (
    <section className="hero-section" aria-label="Repay Security Services introduction">
      <div className="hero-main">
        <div className="hero-media">
          <img
            src={heroImage}
            alt="REPAY Security Services officers, branded patrol vehicle and 24/7 command and control centre outside a commercial building"
            className="hero-media-image"
            fetchpriority="high"
          />
        </div>
        <div className="hero-content">
          <p className="hero-eyebrow">Welcome to Repay Security Services</p>
          <h1 className="hero-heading">
            Professional<br />
            Security Solutions<br />
            <span className="hero-heading-accent">You Can Trust</span>
          </h1>
          <p className="hero-subtext">
            Delivering reliable, innovative and cost-effective security solutions to protect what matters most to you.
          </p>
          <div className="hero-cta-group">
            <Link to="/book-survey" className="hero-btn hero-btn-primary">
              Get a Free Quote <FaChevronRight aria-hidden="true" />
            </Link>
            <Link to="/contact-us" className="hero-btn hero-btn-secondary">
              Contact Us <FaChevronRight aria-hidden="true" />
            </Link>
          </div>
        </div>
      </div>

      <ul className="hero-features">
        {features.map(({ icon: Icon, label }) => (
          <li className="hero-feature-item" key={label}>
            <Icon className="hero-feature-icon" aria-hidden="true" />
            <span>{label}</span>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default HeroSection;
